import {IStore} from '../interfaces/store';

import {ViewIds} from '../constants/views';

export function viewSelector(state: IStore): ViewIds {
  return state.view;
}
